import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
	ModulePayload,
	ModuleAddPayload,
	ModuleUpdatePayload
} from './modules.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ModulesService {

	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;
	private getModulesDTUrl = this.basePath + environment.interop.platform.app.settings.modules.getModulesDT;
	private storeModuleUrl = this.basePath + environment.interop.platform.app.settings.modules.storeModule;
	private putModuleUrl = this.basePath + environment.interop.platform.app.settings.modules.putModule;
	private deleteModuleUrl = this.basePath + environment.interop.platform.app.settings.modules.deleteModule;

	private getModulesUrl = this.basePath + environment.interop.platform.app.settings.modules.getModules;
	private getModulesActiveUrl = this.basePath + environment.interop.platform.app.settings.modules.getModulesActive;
	private getModulesPublicUrl = this.basePath + environment.interop.platform.app.settings.modules.getModulesPublic;

	private changeStatusActiveUrl = this.basePath + environment.interop.platform.app.settings.modules.changeStatusModuleActive;

	constructor(private http: HttpClient) { }

	getModules() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getModulesUrl
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({ id: item.id, name: item.name }))
				),
				catchError((error) => {
					console.error('Error in getUsers:', error);
					return throwError(error);
				})
			);
	}

	getModulesDT() {
		return this.http.get(this.getModulesDTUrl, this.httpOptions);
	}

	addModule(data: ModuleAddPayload) {
		return this.http.post(this.storeModuleUrl, data, this.httpOptions);
	}

	updateModule(data: ModuleUpdatePayload) {
		return this.http.put(this.putModuleUrl, data, this.httpOptions);
	}

	deleteModule(id: number) {
		return this.http.delete(this.deleteModuleUrl + id, this.httpOptions);
	}

	getModuleActive() {
		return this.http.get(this.getModulesActiveUrl, this.httpOptions);
	}

	getModulePublic() {
		return this.http.get(this.getModulesPublicUrl, this.httpOptions);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

	changeStatusModuleActive(id: number) {
		return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
	}
}
